/* Enduristan NL restyle 2026: artikelpagina v1 (27-10). Link kopieren in EN Artikel delen. */
(function () {
  function done(btn) {
    var wrap = btn.closest('.en-art__share');
    var msg = wrap ? wrap.querySelector('[data-en-art-msg]') : null;
    btn.classList.add('is-done');
    if (msg) msg.textContent = btn.getAttribute('data-l-done') || '';
    setTimeout(function () {
      btn.classList.remove('is-done');
      if (msg) msg.textContent = '';
    }, 2500);
  }

  function fallback(text, btn) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); done(btn); } catch (e) {}
    document.body.removeChild(ta);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-en-art-copy]') : null;
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-url') || window.location.href;
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(function () { done(btn); }, function () { fallback(url, btn); });
    } else {
      fallback(url, btn);
    }
  });
})();
